module.exports = __webpack_public_path__ + "static/img/p7.d3c5656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/p7.png
// module id = XHD4
// module chunks = 0